var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chargecallback"},[_vm._v("\n  充值结果： "),_c('span',[_vm._v(_vm._s(_vm.status))]),_vm._v("  充值流水号为："),_c('span',[_vm._v(_vm._s(_vm.reference))]),_vm._v("  充值金额："),_c('span',[_vm._v(_vm._s(_vm.amount))]),_vm._v(" "),_c('div',{staticClass:"btn-rechar"},[_c('router-link',{attrs:{"to":"/Finance/Recharge"}},[_vm._v("查看充值记录")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be4e01e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/web/chargecallback.vue
// module id = null
// module chunks = 